<template>
  <div id="striiv-sleep-stages">
    <mu-card v-if="!striivData.error">
      <mu-divider></mu-divider>
      <mu-row>
        <mu-col width="100" desktop="100" tablet="100" style="border-right: 1px solid #e0e0e0">
          <mu-card-header
            titleClass="largeTitle blackTitle"
            title="Time asleep"
            subTitleClass="timeAsleep"
            :subTitle="normalizeDuration(sleepBreakdown.total)"></mu-card-header>
        </mu-col>
      </mu-row>
      <mu-divider></mu-divider>
      <mu-card-header titleClass="largeTitle blackTitle" title="Stages of sleep" :subTitle="date"></mu-card-header>
      <mu-divider></mu-divider>
      <div>
        <mu-row align="center">
          <mu-col class="padding" width="33" desktop="33" tablet="33" style="border-right: 1px solid #e0e0e0">
            <div>
              <strong>Deep</strong>
            </div>
            <div> {{normalizeDuration(sleepBreakdown.minutes.deep)}}</div>
            <div>{{sleepBreakdown.formatted.deep}}%</div>
          </mu-col>
          <mu-col class="padding" width="33" desktop="33" tablet="33" style="border-right: 1px solid #e0e0e0">
            <div><strong>Light</strong></div>
            <div>{{normalizeDuration(sleepBreakdown.minutes.light)}}</div>
            <div>{{sleepBreakdown.formatted.light}}%</div>
          </mu-col>
          <mu-col class="padding" width="33" desktop="33" tablet="33">
            <div><strong>Awake</strong></div>
            <div>{{sleepBreakdown.awake}}x</div>
          </mu-col>
        </mu-row>
        <mu-divider></mu-divider>
        <mu-card-text style="padding-top:0">
          <div class="accreditation">
            <img src="static/integrations/striiv.png" style="width: 24px">
            Data from Striiv
          </div>
        </mu-card-text>
      </div>
    </mu-card>
    <mu-card v-if="striivData.error">
      <mu-card-header titleClass="largeTitle blackTitle" title="No data" :subTitle="date"></mu-card-header>
    </mu-card>
  </div>
</template>

<script>
  export default {
    name: "striiv-sleep-stages",
    props: {
      date: {
        type: String,
        default: ''
      },
      striivData: {
        type: Object,
        default: {}
      }
    },
    methods: {
      normalizeDuration(minutes) {
        let hourString;
        let minuteString = 'min';
        if (minutes > 60) {
          let hours = Math.floor(minutes / 60);
          let outputMins = minutes % 60;
          if (hours > 1) {
            hourString = 'hrs'
          }
          else {
            hourString = 'hr';
          }
          if (outputMins > 1) {
            minuteString = 'mins';
          }
          else {
            minuteString = 'min';
          }
          return hours + hourString + ' ' + outputMins + minuteString
        }
        return minutes + ' ' + minuteString
      }
    },
    computed: {
      sleepBreakdown() {
        let self = this;
        let data = self.striivData[0];

        if (data) {
          let totals = data.totals;
          let deepMinutes = totals.deep;
          let lightMinutes = totals.light;
          let totalMinutes = (deepMinutes + lightMinutes);
          let awake = data.awakenings;

          let deepPercent = (deepMinutes / totalMinutes * 100);
          let lightPercent = (lightMinutes / totalMinutes * 100);

          return {
            total: totalMinutes,
            deep: deepPercent,
            awake: awake,
            light: lightPercent,
            minutes: {
              deep: deepMinutes,
              light: lightMinutes
            },
            formatted: {
              deep: deepPercent.toFixed(1),
              light: lightPercent.toFixed(1)
            }
          }
        } else {
          return false;
        }
      }
    }
  }
</script>
<style lang="less">

  @rem: #003D44;
  @awake: #FF1C47;
  @deep: #00D7F5;
  @light: #00A6BF;

  #striiv-sleep-stages {
    .mu-card-header-title {
      padding: 0;
    }
    .percentage-bar {
      float: left;
      background: #c9c9c9;
      height: 48px;
      margin-right: 8px;
      &.rem {
        background: @rem;
      }
      &.awake {
        background: @awake;
      }
      &.deep {
        background: @deep
      }
      &.light {
        background: @light;
      }
    }
    .rail {
      margin-bottom: 8px;
    }

    .afterText {
      padding-top: 3px;
    }

    .clear {
      clear: both;
    }

    .bold {
      font-weight: bold;
    }
    .accreditation img {
      margin-top: 8px;
    }
    .accreditation img {
      position: relative;
      top: 7px;
      margin-right: 6px;
      background-color: white;
    }
    .largeTitle {
      font-size: 16px !important;
      color: black
    }
    .mediumTitle {
      font-size: 14px;
      color: black !important;
    }
    .timeAsleep {
      font-size: 24px;
    }
  }
  .col.padding.col-33.tablet-33.desktop-33 {
    padding: 16px;
  }
</style>



// WEBPACK FOOTER //
// StriivSleepStages.vue?47433baa